const state = {
    locale: null
};
const mutations = {
    setLocale(state, locale) {
        state.locale = locale;
        localStorage.setItem('locale', locale);
    }
}
const actions = {
    changeLocale({ commit }, locale) {
        commit('setLocale', locale);
    }
}
const getters = {
    currentLocale: state => state.locale,
}

export default {
    state,
    getters,
    actions,
    mutations,
}